import { AppHelper } from "../appHelper"
import { CommonApp, CommonAppProps, Entity } from "../core/components/commonApp";
import { MetaDataHelper } from "../core/util/metaDataHelper";
import { NotificationHelper } from "../core/util/notificationHelper";
import { DialogHelper } from "../core/util/dialogHelper";
import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import React from "react";
export class EditAllocation extends React.Component<TicketEditAllicationAppProps, any> {
    common = new AppHelper();
    translations: Array<String>;
    isNew = false;

    constructor(props) {
        super(props)
        this.common.init(this);
        this.isNew = this.props.entity.IsNew;
    }


    handleFieldChange = (field, value, dataItem = null, isInit = false) => {
        switch (field.model) {
            case "entity.TicketRef":
                if (value && parseInt(value) === this.props.entity.Ticket) {
                    DialogHelper.alert(this.translations["WebSMS.Ticket.Allocations.SelfSelected"]);
                    value = null;
                }
                break;
            case "entity.RoleId":
                this.props.entity.Role = dataItem ? dataItem[field.dataTextField] : null;
                break;
            default:
                break;
        }

        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    save = async (closeAfterSave) => {
        if (this.common.validate()) {
            const result = await HTTPService.post<JsonResultClass>("ProcedureAllocation/Save", this.props.entity)
            if (result.Code === 0) {
                this.props.entity.IsNew = false;
                this.props.entity.Id = result.Data.Id;
                MetaDataHelper.setReadOnly(this.props.metadata, "entity.TicketRef", true);

                NotificationHelper.showSuccessMessage(this.translations["Standard.Msg.SpeichernErfolgreich"]);
            } else {
                NotificationHelper.showErrorMessage(result.Message);
            }
            this.common.handlePostSave(result.Code === 0, closeAfterSave);
        }
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange });
        return <CommonApp {...props} />;
    }
};

export interface TicketEditAllicationAppProps extends CommonAppProps {
    entity: EntityTicketEditAllocation;
}

export interface EntityTicketEditAllocation extends Entity {
    Ticket: number;
    Id: number;
    Role: string;

}